import { NewsAO } from "types/News"
import { createRemoteReducer, RemoteReducer } from "types/Remote"

export const originalNewsAOReducer: RemoteReducer<NewsAO[]> =
  createRemoteReducer("originalNewsAO")
